import { EnumSubmissionType, EnumSubmissionFileType } from '../enum/enum.js';

/**
 * SubmissionTypeから必要なSubmissionFileTypeの配列を返却する
 * @return Array
 */
export default (types, submissionType) => {
  if (submissionType === EnumSubmissionType.HiRes) {
    return [types[EnumSubmissionFileType.HiRes]];
  } else if (submissionType === EnumSubmissionType.Original) {
    return Object.keys(types)
      .map(number => {
        if (number != EnumSubmissionFileType.HiRes) {
          return types[number];
        }
      })
      .filter(x => x);
  }
};
